import React from 'react';
import UserEmailListTable from "@pages/user/UserEmailListTable";

const YourMailManager = () => {
    return (
        <UserEmailListTable myself/>
    );
};

export default YourMailManager;
